import { ParagraphProps } from "components/paragraph";
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useEffect, useState } from 'react';

import { Button, Container } from '@/atoms';
import { ButtonVariant } from '@/atoms/button/types';


export function PopUp({ paragraph }: ParagraphProps) {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        open && sessionStorage.setItem('popup', true);
    });
    return (
        <>
            <Dialog
                className="fixed inset-0 z-10 overflow-y-auto"
                onClose={() => setOpen(false)}
                open={open}
                transition
            >
                <div className="min-h-screen px-4 text-center md:w-full bg-neutral-900">
                    <DialogBackdrop transition className="fixed inset-0 ease-out duration-300 opacity-80 transition data-[closed]:opacity-0 data-[leave]:ease-in data-[leave]:duration-200" />

                    <span
                        className="inline-block md:h-screen align-middle"
                        aria-hidden="true"
                    >
                        &#8203;
                    </span>
                    <DialogPanel transition className="my-20 md:my-8 inline-block w-4/5 md:w-[800px]  md:h-[400px] transform  bg-white text-left md:align-middle shadow-xl transition-all data-[closed]:opacity-0 data-[closed]:scale-95 data-[leave]:ease-in data-[leave]:duration-200">
                        <div className="flex flex-col md:flex-row">
                            <div
                                className="w1 md:w-1/2"
                                style={{
                                    height: '402px',
                                    backgroundImage: `url(${paragraph.field_image.field_media_image.uri.url})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                }}
                            />
                            <div className="w-full h-auto md:w-1/2 p-6 pt-0">
                                <Container
                                    wrapper
                                    padding="pt-2"
                                    backgroundColor="bg-white"
                                >
                                    <div className="modal-header flex flex-shrink-0 justify-end">
                                        <button
                                            type="button"
                                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => setOpen(false)}
                                        >
                                            x
                                        </button>
                                    </div>
                                    <div className="grid col-span-2 md:pt-8 ">
                                        <p className="text-headline text-headline--h2 text-text-primary mt-3">
                                            {paragraph.field_title}
                                        </p>
                                        <p className="ext-subtitle text-subtitle--l text-body text-body--m mt-5">
                                            {paragraph.field_plain_text}
                                        </p>
                                        <div className="w-max mb-4 mt-9">
                                            <Button
                                                as="a"
                                                variant={ButtonVariant.PRIMARY}
                                                href={paragraph.field_cta.url}
                                            >
                                                {paragraph.field_cta.title}
                                            </Button>
                                        </div>
                                    </div>
                                </Container>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>
        </>
    );
};

